import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiHandlerService } from '../../../../core/api-handlers';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { UtilityService } from '../../../../core/services/utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HotelService } from '../../hotel.service';
import { PubSubService } from '../../../../core/services/pub-sub.service';

@Component({
  selector: 'app-hotel-cancellation',
  templateUrl: './hotel-cancellation.component.html',
  styleUrls: ['./hotel-cancellation.component.scss']
})
export class HotelCancellationComponent implements OnInit, OnDestroy {

  // // HB019-1602676-737019 / 3756906346
  // private subSunk = new SubSink();
  // canceledData: {} = {};
  // isLoading: boolean = true;
  // noOfAdults: number = 0;
  // noOfChilds: number = 0;
  // cancellationDate: {} = {};

  constructor(
    private apiHandlerService: ApiHandlerService,
    private ngxLoader: NgxUiLoaderService,
    private util: UtilityService,
    private router: Router,
    private hotelService: HotelService,
    private activatedRoute: ActivatedRoute,
    private pubSubService: PubSubService,
  ) { }

  ngOnInit(): void {
    // this.getCancelBooking();
    // this.getAllClear();
  }


  // getAllClear() {
  //   this.hotelBookingService.isButtonClickedInPayment.next(false);
  //   this.hotelBookingService.isButtonClickedInReview.next(false);
  //   this.hotelBookingService.isButtonClickedInTraveler.next(false);
  // }

  // getCancelBooking() {
  //   let AppReference;
  //   this.activatedRoute.queryParams.subscribe(q => {
  //     AppReference = q['AppReference']
  //   })
  //   if (!this.hotelService.isDevelopment) {
  //     this.ngxLoader.start()
  //     this.isLoading = true;
  //     this.subSunk.sink = this.apiHandlerService.apiHandler('cancelBooking', 'post', {}, {}, {
  //       AppReference,
  //       Reason: 'testing API'
  //     }).subscribe(resp => {
  //       console.log(resp);
  //       if (resp.statusCode == 201) {
  //         this.canceledData = resp.data;
  //         this.isLoading = false;
  //         this.ngxLoader.stop();
  //       }
  //     }, err => {
  //       this.ngxLoader.stop();
  //       this.pubSubService.publish('formError', {
  //         class: 'alert alert-danger',
  //         msg: 'Oops..! Sorry It seems your ticket has been canelled already.',
  //         timeOut: 3600000,
  //       });
  //     })
  //   } else {
  //     this.isLoading = true;
  //     this.ngxLoader.start();
  //     setTimeout(() => {
  //       this.canceledData = fakeCancellation().data;
  //       this.isLoading = false;
  //       this.ngxLoader.stop();
  //       console.log(this.isLoading, this.canceledData);
  //     }, 3000)
  //   }
  // }

  // getNoOfNights(i, o): number {
  //   let checkin = Number(new Date(i).getTime()), checkout = Number(new Date(o).getTime()), nights: number = 0;
  //   nights = (checkout - checkin) / (1000 * 60 * 60 * 24);
  //   return nights;
  // }

  // getNoOfRoomsCount() {
  //   let totalRoomsBooked: number = 0;
  //   this.canceledData['BookingItineraryDetails'].forEach(o => {
  //     totalRoomsBooked += o['BlockQuantity'];
  //   });
  //   return totalRoomsBooked;
  // }

  // getNoOfGuests() {
  //   let totalGuest: number = 0;
  //   this.noOfChilds = 0; this.noOfAdults = 0;
  //   this.canceledData['BookingPaxDetails'].forEach(o => {
  //     if (o['PaxType'] == 'Child') {
  //       this.noOfChilds++;
  //     } else if (o['PaxType'] == 'Adult') {
  //       this.noOfAdults++
  //     }
  //   });
  //   totalGuest = this.noOfChilds + this.noOfAdults;
  //   return totalGuest;
  // }

  // getRoomType(roomName: string): string {
  //   roomName = roomName.split('-')[0].trim();
  //   return `${roomName}`;
  // }

  // getDatesFormat(date, forInOrOut?) {
  //   date = date.split(' ')[0];
  //   let d = new Date(date).getDate(), m = new Date(date).toDateString().split(' ')[1], y = new Date(date).getFullYear(), day = new Date(date).toDateString().split(' ')[0];
  //   day = this.util.getWeekDay(day);
  //   if (forInOrOut == 'in') {
  //     this.canceledData['BookingDetails']['myCheckinDateTime'] = {
  //       day: `${day}`,
  //       d: `${d}`,
  //       m: `${m}`,
  //       y: `${y}`
  //     }
  //   } else {
  //     this.canceledData['BookingDetails']['myCheckoutDateTime'] = {
  //       day: `${day}`,
  //       d: `${d}`,
  //       m: `${m}`,
  //       y: `${y}`
  //     }
  //   }
  //   return `${day + ', ' + d + ' ' + m + ' ' + y}`
  // }

  // getCheckinCheckoutTimes(t: string): string {
  //   let tm = t.split(' ')[1];
  //   let time = tm.split(':'), hr = 0, min = '00';
  //   hr = Number(time[0]);
  //   if (time.length > 1) {
  //     min = String(time[1])
  //   }
  //   if (hr > 12) {
  //     return `${hr > 12 ? hr - 12 + ':' + min : hr} PM`;
  //   } else if (hr < 12) {
  //     return `${hr + ':' + min} AM`;
  //   } else if (hr == 12) {
  //     return `${hr + ':00'} Noon`;
  //   }
  // }

  // getTimes(t: string): string {
  //   t = t.split(' ')[1];
  //   let time = Number(t.split(':')[0]);
  //   if (time > 11) {
  //     return `${t} PM`;
  //   } else if (time < 12) {
  //     return `${t} AM`;
  //   }
  // }

  // getDate(cancelDatetime: string): string {
  //   let date = cancelDatetime.split(' ')[0];
  //   let d = new Date(date).getDate(), m = new Date(date).toDateString().split(' ')[1], y = new Date(date).getFullYear(), day = new Date(date).toDateString().split(' ')[0];
  //   this.cancellationDate = {
  //     day: `${day}`,
  //     d: `${d}`,
  //     m: `${m}`,
  //     y: `${y}`
  //   }
  //   return `${d + ' ' + m + ' ' + y}`;
  // }

  // getTotalAmnt() {
  //   let totalAmnt: number = 0;
  //   this.canceledData['BookingItineraryDetails'].forEach(o => {
  //     totalAmnt += o.TotalFare;
  //   });
  //   return totalAmnt;
  // }

  // convert(val, currency) {
  //   return this.hotelService.transform(val, currency);
  // }

  // backToSearch() {
  //   this.router.navigate(['/hotel/hotel-search']);
  // }

  ngOnDestroy() {
    // this.subSunk.unsubscribe();
  }

}
